import React, { useContext, useEffect, useState } from "react";
import { Sun, Moon } from "react-feather";
import CustomizerContext from "../../_helper/customizer/index";

const ThemeToggle = ({ size = "md" }) => {
  const { addMixBackgroundLayout } = useContext(CustomizerContext);
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("mix_background_layout");
    return saved === "dark-only" || saved === "dark-sidebar";
  });

  const applyTheme = (dark) => {
    const html = document.documentElement;
    const value = dark ? "dark-only" : "light-only";
    html.classList.toggle("dark", dark);
    html.classList.toggle("light", !dark);
    document.body.classList.toggle("dark-only", dark);
    document.body.classList.toggle("light-only", !dark);
    document.body.classList.toggle("dark-sidebar", false);
    addMixBackgroundLayout?.(value);
  };

  useEffect(() => {
    applyTheme(isDark);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = () => {
    const next = !isDark;
    setIsDark(next);
    applyTheme(next);
  };

  const s = size === "sm" ? 28 : 36;
  const iconSize = size === "sm" ? 14 : 16;

  return (
    <button
      onClick={toggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light mode" : "Dark mode"}
      style={{
        width: s, height: s,
        borderRadius: 10,
        background: isDark
          ? "rgba(99,102,241,0.12)"
          : "rgba(245,158,11,0.1)",
        border: `1px solid ${isDark ? "rgba(99,102,241,0.25)" : "rgba(245,158,11,0.3)"}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        cursor: "pointer", transition: "all 0.2s",
        color: isDark ? "#6366f1" : "#f59e0b",
        flexShrink: 0,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.08)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
    >
      {isDark
        ? <Sun size={iconSize} strokeWidth={2} />
        : <Moon size={iconSize} strokeWidth={2} />}
    </button>
  );
};

export default ThemeToggle;
